import React from 'react';
import api2 from 'src/helpers/api';

class Component extends React.Component {
  componentDidMount() {
    this.props.api('affLists/load');
  }

  add = () => {
    let items = this.props.items;
    items.push({
      id: 0,
      aid: '5',
      name: '',
      wids: ''
    });
    this.props.changeItems(items);
  };

  save = item => {
    item.saving = true;
    item.saved = false;
    this.props.changeItems(this.props.items);
    let data = {
      id: item.id,
      name: item.name,
      wids: item.wids
    };
    api2('affLists/save', data).then(res => {
      if (res && res.id && !res.error) {
        item.id = res.id;
        item.wids = res.wids;
        item.name = res.name;
        item.saved = true;
      } else {
        item.saved = false;
      }
      item.saving = false;
      this.props.changeItems(this.props.items);
    });
  };

  remove = item => {
    if (!confirm('Are you sure?')) return;
    item.removing = true;
    api2('affLists/remove', { id: item.id }).then(res => {
      let items = this.props.items;
      item.removing = false;
      if (res && !res.error) {
        let index = items.indexOf(item);
        items.splice(index, 1);
      }
      this.props.changeItems(items);
    });
  };

  onChange = (e, itemId) => {
    let { name, value } = e.target;
    let items = this.props.items;
    items.map(item => {
      if (item.id == itemId) item[name] = value;
    });
    this.props.changeItems(items);
  };

  render() {
    let { items } = this.props;
    console.log('render', items);
    return (
      <div>
        <table class='table'>
          <thead>
            <tr>
              <th>Id</th>
              <th>Name</th>
              <th>Wids</th>
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {items.length > 0 &&
              items.map(item => (
                <tr key={item.id}>
                  <td>{item.id}</td>
                  <td>
                    <input
                      class='form-control'
                      name='name'
                      value={item.name}
                      onChange={e => this.onChange(e, item.id)}
                    />
                  </td>
                  <td>
                    <textarea
                      class='form-control'
                      name='wids'
                      value={item.wids}
                      onChange={e => this.onChange(e, item.id)}
                    />
                  </td>
                  <td>
                    <div>
                      {!item.saving && (
                        <button class='btn warning' onClick={e => this.save(item)}>
                          Save
                        </button>
                      )}
                      {item.saving && 'Saving'}
                    </div>
                    <div>{item.saved && 'Saved'}</div>
                  </td>
                  <td>
                    <div>
                      {!item.removing && (
                        <button class='btn danger' onClick={e => this.remove(item)}>
                          X
                        </button>
                      )}
                      {item.removing && 'Removing'}
                    </div>
                  </td>
                </tr>
              ))}
          </tbody>
          <tfoot>
            <tr>
              <td>
                <button class='btn success' onClick={this.add}>
                  Add
                </button>
              </td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          </tfoot>
        </table>
      </div>
    );
  }
}

import api from '../actions/api';
import setState from '../actions/state';
import { connect } from 'react-redux';

export default connect(
  function(state) {
    let apiState = state.api.affLists_load || state.api.initial;
    let saveApiState = state.api.affLists_save || state.api.initial;
    return {
      ...apiState.data,
      initial: apiState.initial,
      loading: apiState.loading,
      items: (apiState.data && apiState.data.items) || [],
      saveLoading: saveApiState.loading,
      state: state.state.admin_affLists || state.state.initial,
      user: state.session.user,
      date: Date.now()
    };
  },
  {
    api,
    setState: setState('admin_affLists'),
    changeItems: items => {
      return dispatch => {
        dispatch({
          type: 'api_success',
          key: 'affLists/load',
          items: items
        });
      };
    }
  }
)(Component);
